'use client';
import t from 'tiny-warning';

function deprecatedProp(r, n) {
    let o = false;
    return function(t$1, p, a, d, i, ...u) {
        let c = a || '<<anonymous>>', s = i || p;
        return null == t$1[p] || t$1.__dangerouslySuppressWarning || (t(o, `The ${d} \`${s}\` of \`${c}\` is deprecated. ${n}.`), o || console.warn(`${c}: props received =======>`, t$1), o = true), r(t$1, p, a, d, i, ...u);
    };
}

export { deprecatedProp };
